import { render, staticRenderFns } from "./SearchTransferTable.vue?vue&type=template&id=b0c6db9e"
import script from "./SearchTransferTable.vue?vue&type=script&lang=js"
export * from "./SearchTransferTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports